export default __webpack_public_path__ + "static/media/album.c7a6105d.svg";